<template>
    <div class="historyRecord choose-yet no-record-yet">
        <h1 class="historyRecord_title">
            共找到 {{ total }} 辆车 
            <a href="/buy.htm?store=none&city=none" 
                class="choose_clear" 
                click_type="List-clear-all">清除筛选条件</a>
        </h1>
        <div class="choose_condition">
            <div class="choose_items clearfix">
                <div v-for="item in choose_items"
                    class="choose_item">
                    {{ item.name }}
                    <a @click="removeCondition(item.key)">
                        <span>x</span>
                    </a>
                </div>       
            </div>
            <div class="list_waring hidden"></div>
        </div>
        <div class="historyRecord_content">
            <ul>
            </ul>
        </div>
    </div>
</template>

<script>
    import urlUtil from '@souche-f2e/chunyan-util/url_util/url_util.js';
    const locationObj = urlUtil.initByLocation();
    export default {
        data() {
            return {
                total: (function (listCount) {
                    return (~~listCount.zaiShou) + (~~listCount.yiShou) + (~~listCount.yiyuding);
                })(window._qiwa.page_global.listCount || {}),
                choose_items: []
            };
        },
        created() {
            let searchObj = locationObj.search.object;
            let formBean = window._qiwa.page_global.formBean;
            let choose_items = [];
            if (formBean.cityName) {
                choose_items.push({
                    key: 'city',
                    value: formBean.city,
                    name: formBean.cityName
                });
            }
            if (formBean.storeName) {
                choose_items.push({
                    key: 'store',
                    value: formBean.store,
                    name: formBean.storeName
                });
            }
            for (var i in searchObj) {
                // if (i === 'city') {
                //     if (searchObj[i] && searchObj[i] !== 'none') {
                //         choose_items.push({
                //             key: i,
                //             value: searchObj[i],
                //             name: formBean.cityName
                //         });
                //     }
                // } else if (i === 'store') {
                //     if (searchObj[i] && searchObj[i] !== 'none') {
                //         choose_items.push({
                //             key: i,
                //             value: searchObj[i],
                //             name: formBean.storeName
                //         });
                //     }
                // } else
                if (i === 'carBrand') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.brandName
                    });
                } else if (i === 'carSeries') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.seriesName
                    });
                } else if (i === 'carPrice') {
                    if (searchObj[i] && searchObj[i] !== '0-100000000') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: `${searchObj[i]} 万`
                        });
                    }
                } else if (i === 'carModel') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.chooseModelName
                    });
                } else if (i === 'carMileage') {
                    if (searchObj[i] && searchObj[i] !== '0') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: formBean.mileageName
                        });
                    }
                } else if (i === 'minYear') {
                    let maxYear = searchObj['maxYear'];
                    if (!maxYear) {
                        let d = new Date();
                        maxYear = d.getFullYear();
                    }
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: `${searchObj[i]} - ${maxYear}`
                    });
                } else if (i === 'carEngineVolume') {
                    if (searchObj[i] && searchObj[i] !== '0') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: formBean.engineVolumeName
                        });
                    }
                } else if (i === 'transmissionType') {
                    if (searchObj[i] && searchObj[i] !== '0') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: formBean.transmissionTypeName
                        });
                    }
                } else if (i === 'emissionStandard') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.emissionStandardName
                    });
                } else if (i === 'country') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.countryName
                    });
                } else if (i === 'color') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: formBean.colorName
                    });
                } else if (i === 'keyword') {
                    choose_items.push({
                        key: i,
                        value: searchObj[i],
                        name: searchObj[i]
                    });
                } else if (i === 'bodyModels') {
                    if (searchObj[i] === '5') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: '两厢车'
                        });
                    } else if (searchObj[i] === '6') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: '三厢车'
                        });
                    }
                } else if (i === 'showCarType') {
                    if (searchObj[i] === '1') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: '新车'
                        });
                    } else if (searchObj[i] === '2') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: '二手车'
                        });
                    } else if (searchObj[i] === '3') {
                        choose_items.push({
                            key: i,
                            value: searchObj[i],
                            name: '弹个车'
                        });
                    }
                }
            }
            this.choose_items = choose_items;
        },
        methods: {
            removeCondition(key) {
                if (key === 'city') {
                    locationObj.s(key, 'none')
                        .s('index', null).go();
                } else if (key === 'store') {
                    locationObj.s(key, 'none')
                        .s('index', null).go();
                } else if (key === 'minYear') {
                    locationObj
                        .s('minYear', null)
                        .s('maxYear', null)
                        .s('index', null)
                        .go();
                } else {
                    locationObj.s(key, null)
                        .s('index', null).go();
                }
            }
        }
    };
</script>



// WEBPACK FOOTER //
// HistoryRecord.vue?9662cae6